import React from 'react';
import { Table } from 'reactstrap';
import { getSubjectTimetable, getFrequencyShort } from '../Util/TimetableUtil';

interface TimetableProps {
    timetable: any,
    hasTimetable: boolean
    getExportArr: any
}

interface TimetableState {
    exportArr: any
}

export default class Timetable extends React.Component<TimetableProps, TimetableState> {
    constructor(props: any) {
        super(props)
        this.state = { exportArr: new Array(this.props.timetable.length).fill(true) };
    }

    setInitialExportArr = () => {
        this.props.timetable.map((course: any, index: number) => {
            if (course?.meetings !== undefined) {
                if (course?.meetings[0].startTime === "" || course?.meetings[0].endTime === "") {
                    this.state.exportArr[index] = false;
                }
            } else {
                this.state.exportArr[index] = false;
            }
        })
    }

    componentDidMount() {
        this.setInitialExportArr();
    }


    renderTimetableRows = (returnedArr: any) => {

        //console.log("renderTimetableRows:this.props.timetable.map" + this.props.timetable);

        return this.props.timetable.map((course: any, index: number) => {
            var subject = getSubjectTimetable(course);

            // Check course index empty meeting
            // If empty return conditional so <td> render can omit input for that row (index)
            // returnedArr[index] = 0
            // this.props.getExportArr(returnedArr)
            // move the check to inline?
            let displayExportRow = true;

            try {
                if (course?.meetings !== undefined) {

                    let meeting = course?.meetings[0];

                    if (meeting.startTime === undefined || meeting.endTime === undefined || meeting.startTime === "" || meeting.endTime === "") {
                        displayExportRow = false;
                        returnedArr[index] = false;
                    } else {
                        displayExportRow = true;
                    }
                } else {
                    displayExportRow = false;
                    returnedArr[index] = false;
                }
            } catch (error) {
                console.log(error)
            }

            if (course.meetings === undefined) {
                return (<tr>
                    <td>{subject}</td>
                    <td>{course.sectionCode}</td>
                    <td>{course.session.beginDate}</td>
                    <td>{course.session.endDate}</td>
                    {Array.from({ length: 5 }, (_, index) => (
                        <td key={index}></td>
                    ))}
                </tr>
                )
            } else {
                return (
                    <tr>
                        <td>{subject}</td>
                        <td>{course.sectionCode}</td>
                        <td>{course.meetings.map((meetings: any) => { return (<tr>{meetings.startDate}</tr>) })}</td>
                        <td>{course.meetings.map((meetings: any) => { return (<tr>{meetings.endDate}</tr>) })}</td>
                        <td>{course.meetings.map((meetings: any) => { return (<tr>{meetings.startTime}</tr>) })}</td>
                        <td>{course.meetings.map((meetings: any) => { return (<tr>{meetings.endTime}</tr>) })}</td>
                        <td>{course.meetings.map((meetings: any) => { return (<tr>{meetings.facility}</tr>) })}</td>
                        <td>{course.meetings.map((meetings: any) => { return (<tr>{getFrequencyShort(meetings)}</tr>) })}</td>
                        <td>
                            {displayExportRow ?
                                <input type="checkbox" defaultChecked={true} onChange=
                                    {
                                        (e) => {
                                            returnedArr[index] = e.target.checked;
                                            this.props.getExportArr(returnedArr);
                                        }

                                    }>
                                </input> : ""}
                        </td>
                    </tr>
                )
            }

        })
    }

    render() {

        //console.log("Timetable Render(): " + this.state.exportArr);

        return (
            <div>
                <Table bordered responsive>
                    <thead>
                        <tr>
                            <th scope="col">Course Details</th>
                            <th scope="col">Section</th>
                            <th scope="col">Start Date</th>
                            <th scope="col">End Date</th>
                            <th scope="col">Start Time</th>
                            <th scope="col">End Time</th>
                            <th scope="col">Location</th>
                            <th scope="col">Frequency</th>
                            <th scope="col">Export This?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.renderTimetableRows(this.state.exportArr)}
                    </tbody>
                </Table>
            </div>

        )
    }
}